export default {"src":"/_next/static/media/Tokyo.9d8da2fa.svg","height":73,"width":48};